import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesUp, faAnglesDown, faPlusSquare, faMinusSquare } from "@fortawesome/free-solid-svg-icons";
import SearchField from "../SearchField/SearchField";
import USPositionFormGroup from "./USPositionFormGroup";

import {
  handlePaytermInputChange,
  handlePaytermInputBlur,
  SelectPayType,
  handleDelPayRow,
  handleAddPayRow,
} from "./utils/inputhandlers";
import useUSPosition from "../../hooks/useUSPosition";
import useUSUndo from "../../hooks/useUSUndo";

const PositionsUSAPayment = ({
  // paymentterm,
  // setPaymentterm,
  // paymenttermData,
  // setPaymenttermData,
  // handlePaytermInputChange,
  // handlePaytermInputBlur,
  // SelectPayType,
  ignoreEnter,
  clearfield,
  loadedPayterm,
  loadedPaytermData,
}) => {
  const { paymentterm, setPaymentterm, paymenttermData, setPaymenttermData, paytermHash, payrow, positiontoedit } =
    useUSPosition();
  const { setEditingField, positionEdits, editID, setEditID, editingField, undoList, setReloadpayterms, inputRefs } =
    useUSUndo();
  return (
    <fieldset>
      <legend>
        Payment Terms:
        <FontAwesomeIcon
          icon={faPlusSquare}
          onClick={(e) =>
            handleAddPayRow(
              setPaymentterm,
              setPaymenttermData,
              payrow,
              positionEdits,
              editID,
              setEditID,
              undoList,
              loadedPayterm,
              loadedPaytermData,
              positiontoedit
            )
          }
        />
      </legend>
      <USPositionFormGroup
        labelname={"Interest Rate"}
        inputname={"interest"}
        inputtype={"percent"}
        style={{ minWidth: "45px", maxWidth: "55px", marginBottom: "1rem", textAlign: "right" }}
      />
      <div className='USpayterms'>
        <div className='USpayterm-headers'>
          <p></p>
          <p>Portion</p>
          <p>Type</p>
          <p>Days</p>
        </div>
        {paymentterm &&
          paymentterm.map((el, ind) => {
            // console.log(paymentterm);
            let paykeys = Object.keys(el);
            return (
              <div key={"posrowpay-" + ind} className='USpayterm-content'>
                <p>{ind + 1 + ":"}</p>
                {paykeys &&
                  paykeys.map((el1) => {
                    if (el1 !== "positionID" && el1 !== "posPaytermID" && el1 !== "row" && el1 !== "type") {
                      if (el1 !== "payType") {
                        return (
                          <input
                            required
                            id={el1 + ind}
                            autoComplete='off'
                            key={ind + "-" + el1}
                            name={el1}
                            value={el[el1]}
                            onFocus={(e) => e.target.select()}
                            onChange={(e) => {
                              handlePaytermInputChange(
                                ind,
                                el1,
                                e,
                                paymentterm,
                                paymenttermData,
                                setPaymentterm,
                                setPaymenttermData,
                                setEditingField
                              );
                            }}
                            onBlur={(e) => {
                              handlePaytermInputBlur(
                                ind,
                                el1,
                                e,
                                paymentterm,
                                setPaymentterm,
                                positionEdits,
                                editingField,
                                editID,
                                setEditID,
                                setEditingField,
                                undoList,
                                paymenttermData
                              );
                            }}
                            onKeyDown={ignoreEnter}
                            ref={(elem) => {
                              // console.log(el1 + (el?.posPaytermID || el?.row));
                              return (inputRefs.current[el1 + (el?.posPaytermID || el?.row)] = elem);
                            }}
                          />
                        );
                      } else {
                        return (
                          <SearchField
                            key={ind + "-" + el1}
                            required={true}
                            searchURL='/api/positions/getpaytypes'
                            value={el[el1] || ""}
                            valueName='payType'
                            refName={"payType" + (el.posPaytermID || el.row)}
                            valueID='payTypeID'
                            style={{ width: "40px" }}
                            customplaceholder='payType'
                            onItemSelect={(item) => {
                              SelectPayType(
                                item,
                                ind,
                                paymentterm,
                                setPaymentterm,
                                paymenttermData,
                                setPaymenttermData,
                                editingField,
                                positionEdits,
                                editID,
                                el1,
                                setEditID,
                                setEditingField,
                                undoList
                              );
                            }}
                            clearfield={clearfield}
                          />
                        );
                      }
                      // return <input value={el[el1]} />;
                    }
                  })}{" "}
                <p>
                  <FontAwesomeIcon
                    style={{ marginLeft: "0.4rem" }}
                    icon={faMinusSquare}
                    // onClick={(e) => {
                    //   if (paymentterm.length > 1) {
                    //     setPaymentterm((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
                    //     setPaymenttermData((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
                    //     setReloadpayterms((prev) => !prev);
                    //   }
                    // }}
                    onClick={(e) =>
                      handleDelPayRow(
                        paymentterm,
                        paymenttermData,
                        setPaymentterm,
                        setPaymenttermData,
                        setReloadpayterms,
                        ind,
                        positionEdits,
                        editID,
                        setEditID,
                        undoList,
                        payrow,
                        loadedPayterm,
                        loadedPaytermData
                      )
                    }
                  />
                </p>
              </div>
            );
          })}
      </div>
    </fieldset>
  );
};

export default PositionsUSAPayment;
